import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';

import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Typography,
  Select,
  Step,
  StepLabel,
  Stepper
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import MapsCollection from '../../../api/Maps/Maps';
import { getPublicId } from '../../../api/Maps/map-operations';
import InternationalPhoneNumber from '../InternationalPhoneNumber';

const MapShareByEmailMobile = props => {
  const { mapList, shareOptions } = props;
  const { buttonByEmailMobile } = shareOptions;
  const [openModal, setOpenModal] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [mapSelected, setMapSelected] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [completeNumber, setCompleteNumber] = React.useState('');
  const [typeToSend, setTypeToSend] = React.useState('email');
  const steps = ['Scan qr code', 'Enter the data'];
  const [activeStep, setActiveStep] = React.useState(0);
  const [subjectEmail, setSubjectEmail] = React.useState('');
  const [bodyEmail, setBodyEmail] = React.useState('');

  const renderButtons = () => {
    if (!isEmpty(buttonByEmailMobile.libraryIcon)) {
      if (buttonByEmailMobile.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME) {
        return (
          <FontAwesomeIcon
            style={{ color: '2A3F90', marginRight: '5px' }}
            icon={buttonByEmailMobile.iconFontawesome}
          />
        );
      }
      if (buttonByEmailMobile.libraryIcon === LIBRARY_ICON_TYPES.SVG) {
        return (
          <img
            src={buttonByEmailMobile.iconSvg}
            alt={buttonByEmailMobile.iconFontawesome}
            style={{ color: '2A3F90', height: '20px', marginRight: '5px', width: '20px' }}
          />
        );
      }
    }

    return '';
  };

  const sendEmailToBack = async () => {
    const response = await fetch(
      'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/send_email',
      {
        method: 'POST',
        body: JSON.stringify({
          bodyEmail,
          email_to: email,
          shared: mapSelected.url,
          subject: subjectEmail
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      }
    );
    const respuesta = await response.json();
    if (respuesta && respuesta.status) {
      Bert.alert('Mensaje enviado al correo electrónico', 'success');
    } else {
      Bert.alert(respuesta, 'info');
    }
  };

  const sendMobileToBack = async () => {
    const response = await fetch(
      'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/message_whatsapp',
      {
        method: 'POST',
        body: JSON.stringify({
          message,
          phone: completeNumber,
          url: mapSelected.url
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      }
    );
    const respuesta = await response.json();
    if (respuesta && respuesta.status) {
      Bert.alert('Mensaje enviado al móvil', 'success');
    } else {
      Bert.alert(respuesta, 'info');
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleNext = () => {
    if (typeToSend === 'email') {
      if (isEmpty(email)) {
        Bert.alert('Not all fields are completed', 'warning');
      } else {
        sendEmailToBack();
        setOpenModal(false);
      }
    } else if (activeStep === steps.length - 1) {
      if (typeToSend === 'mobile' && !isEmpty(completeNumber) && !isEmpty(mapSelected)) {
        sendMobileToBack();
        setOpenModal(false);
        setActiveStep(0);
      } else {
        Bert.alert('Not all fields are completed', 'warning');
      }
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleChangeMap = event => {
    const newMapSelected = mapList.find(item => item._id === event.target.value);
    const url = Meteor.absoluteUrl(`shared/maps/${getPublicId(newMapSelected)}`);
    setMapSelected({ url, id: event.target.value });
  };

  const body = (
    <Box backgroundColor="white" width="60vw" height="60vh">
      <Box display="flex" height="10%" width="90%" alignItems="center" mr={5}>
        <Grid container direction="row" justifyContent="space-around" spacing={2}>
          <Grid item xs={1} />
          <Grid item xs={3} sx={{ display: 'flex' }}>
            <ButtonGroup variant="contained" aria-label="outlined primary button group">
              <Button
                style={{
                  fontSize: 11,
                  backgroundColor: typeToSend === 'email' ? '#2A3F90' : 'inherit',
                  color: typeToSend === 'email' ? 'white' : 'inherit',
                  size: 'small',
                  border: '1px solid #2A3F90'
                }}
                onClick={() => setTypeToSend('email')}
                disabled={typeToSend === 'email'}
              >
                By email
              </Button>
              <Button
                style={{
                  fontSize: 11,
                  backgroundColor: typeToSend === 'mobile' ? '#2A3F90' : 'inherit',
                  color: typeToSend === 'mobile' ? 'white' : 'inherit',
                  size: 'small',
                  border: '1px solid #2A3F90'
                }}
                onClick={() => setTypeToSend('mobile')}
                disabled={typeToSend === 'mobile'}
              >
                By mobile
              </Button>
            </ButtonGroup>
          </Grid>
          <Grid item xs={7}>
            {typeToSend === 'mobile' && (
              <Stepper nonLinear activeStep={activeStep}>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel color="inherit">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </Box>
      <Box height="75%" width="75%" m={3} justifyContent="center">
        {typeToSend === 'mobile' && (
          <>
            {activeStep === 0 && (
              <>
                <Typography variant="h6" align="center" gutterBottom>
                  Scan and send `join cap-half`
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: 'auto',
                    mb: 2
                  }}
                >
                  <img
                    src="https://sd1.d3.ipsilum.com/files_uploaded/twilio.svg"
                    alt="QR code for scanning"
                    style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </>
            )}
            {activeStep === 1 && (
              <>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="demo-select-label">Map</InputLabel>
                  <Select
                    labelId="demo-select-label"
                    id="demo-select"
                    label="Map"
                    size="small"
                    value={mapSelected.id || ''}
                    onChange={event => handleChangeMap(event)}
                  >
                    {mapList.map(item => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  id="outlined-required"
                  label="Message"
                  size="small"
                  sx={{ mb: 2 }}
                  value={message}
                  onChange={event => setMessage(event.target.value)}
                  fullWidth
                />
                <InternationalPhoneNumber setCompleteNumber={setCompleteNumber} />
              </>
            )}
          </>
        )}
        {typeToSend === 'email' && (
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              mb: 2
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-select-label">Map</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Map"
                size="small"
                value={mapSelected.id || ''}
                onChange={event => handleChangeMap(event)}
              >
                {mapList.map(item => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="outlined-required"
              fullWidth
              label="Insert Email"
              onChange={event => setEmail(event.target.value)}
              size="small"
              sx={{ mb: 2 }}
              value={email}
            />
            <TextField
              id="outlined-required"
              fullWidth
              label="Subject of the email"
              onChange={event => setSubjectEmail(event.target.value)}
              size="small"
              sx={{ mb: 2 }}
              value={subjectEmail}
            />
            <TextField
              id="outlined-required"
              fullWidth
              label="Body of the email"
              onChange={event => setBodyEmail(event.target.value)}
              size="small"
              sx={{ mb: 2 }}
              value={bodyEmail}
            />
          </Box>
        )}
      </Box>
      <Box height="10%" width="90%" m={2} justifyContent="space-between">
        <Button
          disabled={activeStep === 0}
          sx={{
            color: '#2A3F90'
          }}
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          sx={{
            color: 'white',
            backgroundColor: '#2A3F90'
          }}
          onClick={handleNext}
        >
          {activeStep === steps.length - 1 || typeToSend === 'email' ? 'Send' : 'Next'}
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      {buttonByEmailMobile && !isEmpty(buttonByEmailMobile) && (
        <>
          <Box display="flex" flexDirection="row" gap={2}>
            <Button
              onClick={() => {
                setOpenModal(true);
              }}
            >
              {buttonByEmailMobile.icon ? buttonByEmailMobile.icon : renderButtons()}{' '}
              {!isEmpty(buttonByEmailMobile.name) && buttonByEmailMobile.name}
              Send Email
            </Button>
          </Box>
          <Modal
            open={openModal}
            style={{
              bgcolor: 'white',
              top: '20vh',
              left: '20vw'
            }}
            onClose={() => setOpenModal(false)}
          >
            {body}
          </Modal>
        </>
      )}
    </>
  );
};

MapShareByEmailMobile.defaultProps = {
  mapList: [],
  buttonByEmailMobile: {}
};

MapShareByEmailMobile.propTypes = {
  buttonByEmailMobile: PropTypes.object,
  shareOptions: PropTypes.object.isRequired,
  mapList: PropTypes.array
};

export default withTracker(({ isPublicMap, map }) => {
  const allMapsSub = isPublicMap !== true && Meteor.subscribe('maps.all');
  const mapList = isPublicMap === true ? [map] : MapsCollection.find({}).fetch();

  const loading = isPublicMap || !allMapsSub.ready();

  return {
    loading,
    mapList
  };
})(MapShareByEmailMobile);
